<template>

    <main class="temoignages-body-template">
        <article>
            <section class="text-right">
                <figure>
                    <img class="picture" v-if="item.picture" :src="require('../../assets/' + item.picture)" alt="">
                    <figcaption>
                        <p :class="item.color">BAPTISTE BAUDET</p>
                        <p class="green">COMPANY DIRECTOR IN <br />SAINT-REMY-LES-CHEVREUSE (78)</p>
                    </figcaption>
                </figure>
                <p class="number" :class="item.color">
                    250,000
                </p>

                <p class="green uppercase semiBold">
                  customers have taken up the new health insurance product in Hungary. 
                </p>



                <img class="icono w300" :src="require('../../assets/t4.jpg')">
                <p class="label green">
                   RELAIMOI
                </p>

                <p class="green uppercase semiBold">
                    A unique product which allow to share health assistance cover with family members.

                </p>
				<iframe width="560" height="200" src="https://www.youtube.com/embed/yGSQ2BebijM" frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>

                <p class="label green">
                 TAILORMADE POLICY
                </p>

                <p class="green uppercase semiBold">
                   Dedicated critical illness cover from <br>Gan Eurocourtage.
                </p>

            </section>

            <section>
                <svg class="quote" :class="item.color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.8 42.61">
                    <path d="M59.8,0H45.59C39,11,34.91,18,33.43,20.83a17.92,17.92,0,0,0-2.17,8.26c0,7.57,6.36,13.52,14.34,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5ZM28.55,0H14.21C7.57,11.09,3.65,18.13,2.16,21A17.49,17.49,0,0,0,0,29.09c0,7.57,6.22,13.52,14.2,13.52s14.2-6,14.2-13.52c0-5.28-2.7-9.2-8.11-11.5Z"/>
                </svg>
                <h2> Groupama’s support for the Sévéane network is a guarantee of stability, dependability and quality.</h2>
                <h1> 
                    <span>Acting with</span>
                    <span>BAPTISTE and all </span>
                    <span>our <em style="color: #d95c74">partners to</em></span>
                    <span><em style="color: #d95c74">offer better</em></span>
                    <span><em style="color: #d95c74"> health protection</em></span>
                </h1>

                <!--<h3>
                    à la tête d'une exploitation<br>
                    de 350 HA, en blé, colza et orge
                </h3>-->

                <p>
                    Baptiste has been an optician for 26 years, and has worked for several leading specialist brands. But for the past 15 or so years, he has run his own business in Saint-Rémy-Lès-Chevreuse, near Paris. In 2016, he joined the <span class="marker" :class="item.color">Sévéane</span> network, the online health community set up to improve health services under a partnership between private health insurer Groupama and its 6 million beneficiaries. This initiative and extension of services has grown out of a partnership agreement between Groupama and PRO BTP, the Construction and Civil Engineering industry welfare protection provider.
                    <br><br>
                    Membership of Sevéane means that Baptiste is now able to work with a larger number of lens manufacturers to meet the growing demand from policyholders for eyewear at lower cost.<br><br>
                    In eye care especially, the amount remaining payable by policyholders after state reimbursement can often be high. It is against this background that mutual and private health insurers have formed partnerships with networks of healthcare professionals to ensure that their customers receive high-quality care at a fair price. <br><br>
“Day-to-day management is very straightforward. All the information is entered into the website, and the amount payable by the policyholder is calculated immediately!”

                    <br><br>
                   “Groupama is a recognised and popular company within its sector, so the support it gives the Sévéane network is an additional guarantee of stability, dependability, quality and close relationships for professionals and policyholders”, says Baptiste. <br><br>
Groupama, Sévéane and the members of its network work towards the same goals and share the same commitment to working as closely as possible with their customers to meet their needs. 


                </p>

                <a href="" class="link">
                    <svg class="link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 324">
                        <path d="M239,260v56a7.89,7.89,0,0,1-8,8H40A40.12,40.12,0,0,1,0,284V40A40.12,40.12,0,0,1,40,0H242c4,0,8,4,8,8V252a7.89,7.89,0,0,1-8,8Zm-16,16V260H40a23.69,23.69,0,0,0-24,24c0,14,10,24,24,24H223V292H37V276Zm11-31V16H40C26,16,16,26,16,40V253c7-5,14-8,24-8Z"/>
                        <path d="M197,64v61H52V64ZM183,78H67v33H183Z"/>
                    </svg>
                    <div class="link-content">
                        <p>To learn more about the facts that marked our year</p>
                        <p><span>DOWNLOAD</span> THE ANNUAL REPORT</p>
                    </div>
                </a>

            </section>
        </article>
    </main>


</template>

<script>

    export default {
        name: "TemoignageBody",
        props: ['item'],
        mounted() {

            window.removeEventListener('scroll', this.scroll)
            window.addEventListener('scroll', this.scroll)

        },
        methods: {
            scroll() {
                if(!document.querySelector('.temoignages-item-bar.active'))
                    return;

                if (this.isInViewport(document.querySelector('.temoignages-item-bar.active')))
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 0;
                else
                    document.querySelector('.temoignages-item-bar.active + .temoignages-item-content .close').style.opacity = 1;
            },
            isInViewport(elem) {
                let bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= -document.querySelector('.temoignages-item-bar.active').clientHeight &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }
        }
    }
</script>
